import React from "react";
import { useIntl } from "react-intl";
import { agendaDeviation, handledElsewhere } from "../../utils/agendaLabel";
import css from "./Agenda.module.css";
export var AgendaBadges = function (_a) {
    var _b, _c;
    var agenda = _a.agenda, globalType = _a.globalType, link = _a.link, _d = _a.linkSide, linkSide = _d === void 0 ? "monograph" : _d, listedIn = _a.listedIn;
    var formatMessage = useIntl().formatMessage;
    var elsewhere = !!listedIn && handledElsewhere(agenda, listedIn);
    var deviation = agendaDeviation(agenda, globalType);
    var deviationText = deviation
        ? formatMessage({ id: "ui-br-legaldeposits.agenda.badge.deviation" }, deviation)
        : null;
    var linkText = !link
        ? null
        : linkSide === "monograph"
            ? formatMessage({ id: "ui-br-legaldeposits.agenda.badge.linkedToIssue" }, {
                issue: link.issueLabel,
                periodical: (_b = link.periodicalTitle) !== null && _b !== void 0 ? _b : "",
            })
            : formatMessage({ id: "ui-br-legaldeposits.agenda.badge.linkedToMonograph" }, { monograph: (_c = link.monographTitle) !== null && _c !== void 0 ? _c : "" });
    var handledByText = elsewhere && agenda
        ? formatMessage({
            id: "ui-br-legaldeposits.agenda.badge.handledBy.".concat(agenda),
        })
        : null;
    return (React.createElement(React.Fragment, null,
        handledByText && (React.createElement("span", { className: css.handledByBadge, title: deviationText !== null && deviationText !== void 0 ? deviationText : handledByText, "data-test-id": "agenda-handled-by-badge", "data-agenda": agenda }, handledByText)),
        deviationText && !handledByText && (React.createElement("span", { className: css.badge, title: deviationText, "data-test-id": "agenda-badge" }, deviationText)),
        linkText && (React.createElement("span", { className: css.linkBadge, title: linkText, "data-test-id": "agenda-link-badge" }, linkText))));
};
